module.exports = __webpack_public_path__ + "static/media/Portrait-10065.84a63eaf.jpg";